import { render, staticRenderFns } from "./orglist.vue?vue&type=template&id=33e546b0"
import script from "./orglist.vue?vue&type=script&lang=js"
export * from "./orglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports